import React from 'react';
import { Snackbar, Alert, AlertColor, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { NotificationMessage, NotificationLevel } from './types';

interface NotificationSnackbarProps {
  notification: NotificationMessage;
  onClose: (id: string) => void;
}

const getAlertSeverity = (level: NotificationLevel): AlertColor => {
  switch (level) {
    case 'info':
      return 'info';
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
    default:
      return 'info';
  }
};

export const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  notification,
  onClose,
}) => {
  const handleClose = () => {
    onClose(notification.id);
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={notification.autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        severity={getAlertSeverity(notification.level)}
        variant="filled"
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};
